import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MapLayoutComponent } from './map-layout/map-layout.component';
import { Route, RouterModule } from '@angular/router';
import { ModuleAuthGuard } from 'app/core/auth/guards/module_auth.guard';
import { MapHistoryComponent } from './map-history/map-history.component';
import { MainMapModule } from './map-layout/map-main/main-component.module';

const mapRoutes: Route[] = [
  {
    path:'',
    component: MapLayoutComponent,
    canActivate: [ModuleAuthGuard],
    data: { 'module': 'MAPS', 'page': 'maps' }
  },
  {
    path:':user_uid/history',
    component: MapHistoryComponent,
    canActivate: [ModuleAuthGuard],
    data: { 'module': 'MAPS', 'page': 'maps_history' }
  }
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(mapRoutes),
    MainMapModule
  ],
  exports:[
    MainMapModule
  ]
})
export class MapsModule { }
